export const FETCH_CANDIDATE_REQUEST = 'FETCH_CANDIDATE_REQUEST'
export const FETCH_CANDIDATE_SUCCESS = 'FETCH_CANDIDATE_SUCCESS'
export const FETCH_CANDIDATE_FAILURE = 'FETCH_CANDIDATE_FAILURE'

export const fetchCandidateRequest = () => ({
  type: FETCH_CANDIDATE_REQUEST
})

export const fetchCandidateSuccess = candidate => ({
  type: FETCH_CANDIDATE_SUCCESS,
  payload: candidate
})

export const fetchCandidateFailure = error => ({
  type: FETCH_CANDIDATE_FAILURE,
  payload: error
})

export const fetchCandidateByEmail = (tenant, email) => {
  return async dispatch => {
    dispatch(fetchCandidateRequest())
    try {
      const token = localStorage.getItem('token')
      const response = await fetch(`${tenant.getApiUrl('candidate')}/email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ email })
      })
      if (!response.ok) {
        throw new Error('Failed to retrieve candidates')
      }
      const data = await response.json()
      console.log(data, 'dataaaaaaaaaaaaaaaaaaaaaaaaa')
      dispatch(fetchCandidateSuccess(data.res || []))
    } catch (error) {
      dispatch(fetchCandidateFailure(error.message))
    }
  }
}
